import { api } from "./client.js";

const D = "/api/v1/dashboard";

export const billingApi = {
  get: () => api.get<{
    tier: string;
    messages_used: number;
    messages_limit: number;
    overage_credits: number;
    billing_period_start?: string;
    billing_period_end?: string;
    tokens_used_input: number;
    tokens_used_output: number;
    chunks_stored: number;
    chunks_limit: number;
  }>(`${D}/billing`),

  checkout: (price_key: string) =>
    api.post<{ checkout_url: string }>(`${D}/billing/checkout`, { price_key }),

  portal: () =>
    api.post<{ portal_url: string }>(`${D}/billing/portal`),
};
